import React from 'react';
import FormInput from '../Form/FormInput';
import { Container, Row, Col } from 'reactstrap';
import { FormLabel } from '../Form/FormLabel';
import { Input } from 'reactstrap';
import { useEdit } from '../../Services/EditContext';
import { getIn, useFormikContext } from 'formik';
const BooleanInput = ({ id, label, offLabel, onLabel }) => {
    const [edit] = useEdit();
    const { setFieldValue, values } = useFormikContext();
    const value = getIn(values, id);
    const handleChange = (e) => {
        setFieldValue(id,e.target.checked);
    }

    return <React.Fragment>
        {edit ? <div style={{ display: 'flex', width: '21px' }}></div> : null}
        <Col> {edit ? 
            <FormLabel check htmlFor={id}>
                <Input type='checkbox' id={id} name={id} placeholder={label} checked={value} onChange={handleChange} />{label}
            </FormLabel>
            : <FormLabel>{value ? (onLabel ? onLabel : label) : (offLabel ? offLabel : '')}</FormLabel>}
        </Col>
    </React.Fragment>
}
const AdminDetail = (props) => {
    const { invite } = props;
   
  
    //<StringSelector id='catering' label="Catering" list={charterTypes?.catering} />
    //<BooleanInput id='shared' label='Shared' />
    return <Container>
        <Row>
            <Col>
                <Row>
                    <Col>
                        <FormInput id='firstName' label='First Name' />
                    </Col>
                    <Col>
                        <FormInput id='lastName' label='Last Name' />
                    </Col>
                </Row>
                <Row>

                    <BooleanInput id='managesWorkflow' label='Manages Workflow' />
                    <BooleanInput id='managesMessages' label='Manages Email' />

                </Row>
                <Row>

                    <Col>
                        <FormInput readOnly={!invite} id='email' label='Email' />
                    </Col>
                </Row>

            </Col>
        </Row>
    </Container>

};

export default AdminDetail;




